import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import Work from "@/components/Work";
import Services from "@/components/Services";
import Founders from "@/components/Founders";
import Daisy from "@/components/Daisy";
import Contact from "@/components/Contact";

const TITLES = { work: "nav.work", services: "nav.services", studio: "nav.founders", contact: "nav.cta" };
const SUMMARY = { work: "work.side", services: "services.side", studio: "founders.p2", contact: "formPlus.customHelp" };
const INDEX = { work: "01", services: "02", studio: "03", contact: "04" };
export default function StudioPage({ page }) {
  const { t } = useLanguage();
  return <div className="studio-subpage" data-testid={`${page}-page`}>
    <header className={`page-masthead page-masthead-${page}`} id="top"><div className="page-masthead-art" aria-hidden="true"><img src="/images/studio-cinematic.webp" alt="" width="2400" height="1100" /></div><div className="studio-container page-lead"><div className="page-breadcrumb mono-label"><Link to="/" data-testid={`${page}-home-link`}>WEB BUILDERS</Link><span>/</span><span>{t(TITLES[page])}</span><span className="page-edition">{INDEX[page]} / STUDIO JOURNAL</span></div><div className="page-title-row"><div><h1 data-testid={`${page}-page-title`}>{t(TITLES[page])}<span>.</span></h1><p className="page-summary" data-testid={`${page}-page-summary`}>{t(SUMMARY[page])}</p></div><ArrowUpRight aria-hidden="true" size={52} strokeWidth={1} /></div></div></header>
    {page === "work" && <Work />}
    {page === "services" && <Services />}
    {page === "studio" && <><Founders /><Daisy /></>}
    <Contact />
  </div>;
}